import React from 'react';
import { NoLinkAppearance as EmotionNoLinkAppearance } from './styled-emotion';
import { NoLinkAppearance as CompiledNoLinkAppearance } from './styled-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
export var NoLinkAppearance = function NoLinkAppearance(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledNoLinkAppearance, props) : /*#__PURE__*/React.createElement(EmotionNoLinkAppearance, props);
};